import MyBusiness from './MyBusiness';
import GrowthAndMarketing from './GrowthAndMarketing';
import Analytics from './Analytics';
import HelpAndResources from './HelpAndResources';
import Avatar from './Avatar';
import './style.scss';

const SubMenus = {
    MyBusiness,
    GrowthAndMarketing,
    Analytics,
    HelpAndResources,
    Avatar,
};

export default SubMenus;
